import { Position } from '../common';
import { Visibility } from '../visibility/visibility.types';
import { FieldKind } from './field.types';

export interface FieldPositionData {
  fieldsetId: number;
  fields: Position[];
}

export interface FieldsetUpdateData {
  id: number;
  name?: string;
  category?: string | null;
  default?: boolean;
}

export type FieldsetPositionData = {
  fieldsets: Position[];
};

export interface Field {
  id?: number;
  name?: string;
  fixed?: boolean;
  origin?: 'parsed' | 'manual';
  kind: FieldKind;
  values: FieldValue;
  options?: { values?: any[] };
  visibility?: Visibility | null;
  visible?: boolean;
}

export type FieldValue = Array<
  | { text: string }
  | { flag: boolean }
  | { value: string }
  | { languageCode: string; languageName?: string; level: string }
  | { countryCode: string; countryName?: string }
  | Experience
  | Education
  | { date: string }
>;

export const informationKinds: FieldKind[] = Object.values(FieldKind).filter(
  kind => kind !== FieldKind.Education && kind !== FieldKind.Experience,
);

export const basicKinds: FieldKind[] = [
  FieldKind.SingleLine,
  FieldKind.MultiLine,
  FieldKind.Dropdown,
  FieldKind.Boolean,
];

export const specialKinds: FieldKind[] = informationKinds.filter(
  kind =>
    kind !== FieldKind.SingleLine &&
    kind !== FieldKind.MultiLine &&
    kind !== FieldKind.Dropdown &&
    kind !== FieldKind.Boolean,
);

export type LanguageValue = Array<{ languageCode: string; languageName?: string; level: string }>;

export interface LanguageField extends Field {
  name: string;
  values: LanguageValue;
}

export type NationalityValue = Array<{ countryCode: string; countryName?: string }>;

export interface NationalityField extends Field {
  name: string;
  values: NationalityValue;
}

export interface SelectField extends Field {
  name: string;
  values: Array<{ value: string }>;
}

export interface BooleanField extends Field {
  name: string;
  values: Array<{ flag: boolean }>;
}

export interface TextField extends Field {
  name: string;
  values: Array<{ text: string }>;
}

export interface DateField extends Field {
  name: string;
  values: Array<{ date: string }>;
}

export interface ExperienceField {
  id?: number;
  kind: FieldKind;
  values: Experience[];
}

export interface EducationField {
  id?: number;
  kind: FieldKind;
  values: Education[];
}

export interface Education {
  school: string;
  degree: string;
  major?: string;
  startDate: string;
  endDate?: string | null;
  description?: string;
}

export interface Experience {
  title: string;
  startDate: string;
  location: string;
  endDate?: string | null;
  description?: string;
  company: string;
}

export type SearchableField = {
  name: string;
  searchKey: string;
};
